module.exports = __webpack_public_path__ + "img/midshift-screening.04429cf9.png";